function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WhiteboardTool } from './WhiteboardTool';
import { flattenDeep } from 'lodash';
export class LineTool extends WhiteboardTool {
  constructor(enableToolEvent, modelGetter, shadowEmitter, scope) {
    super(enableToolEvent, modelGetter, shadowEmitter, scope);
    _defineProperty(this, "elementModel", null);
    _defineProperty(this, "from", null);
    _defineProperty(this, "to", null);
    _defineProperty(this, "showLiveCursor", true);
    this.tool.minDistance = 1;
  }
  onMouseDown(event) {
    if (this.elementModel) {
      this.elementModel.dispose();
    }
    this.elementModel = null;
    this.modelGetter().then(model => {
      if (model) {
        this.elementModel = model.createLinePath(true);
      }
    });
    this.from = event.point.clone();
    this.to = event.point.clone();
  }
  onMouseDrag(event) {
    if (this.from && this.elementModel) {
      this.to = event.point.clone();
      const path = new this.scope.Path.Line(this.from, this.to);
      const points = new Array(MAX_LINE_POINTS).fill(0).map((item, index) => {
        const distance = index / (MAX_LINE_POINTS - 1) * path.length;
        const point = path.getPointAt(distance);
        return [point.x, point.y];
      });
      this.elementModel.setPoints(flattenDeep(points));
    }
  }
  onMouseUp(_event) {
    // 检查两个point距离, 太近不渲染
    if (this.elementModel) {
      this.elementModel.shadow = '';
    }
  }
}
export const MAX_LINE_POINTS = 5;